module.exports = __webpack_public_path__ + "static/media/fi-rr-eye.a89adc38.svg";